import React, { useState } from 'react';
import classnames from 'classnames';
import FilterItem from './Item';

import type { IBaseProps } from '@home/types/common';
import type { FilterItemType, SelectValuesType, IChangeHandler } from './types';

import './index.scss';

interface IFilterProps extends IBaseProps {
  options: FilterItemType[];
  onChange?: IChangeHandler | null;
}

const DEFAULT_OPTIONS: FilterItemType[] = [];

const Filter: React.FC<IFilterProps> = (props) => {
  const { style, className, options = DEFAULT_OPTIONS, onChange = null } = props;

  const [selectValues, setSelectValues] = useState<SelectValuesType>({});
  const [lastSelectValues, setLastSelectValues] = useState<SelectValuesType>({});

  return (
    <section style={style} className={classnames('gp-general-select-filter', className)}>
      {Array.isArray(options) &&
        options.map((option: FilterItemType) => {
          const { fieldName, refreshRenderKey } = option || {};
          return (
            <FilterItem
              key={`${fieldName}_${String(refreshRenderKey)}`}
              options={option}
              allOptions={options}
              selectValues={selectValues}
              setSelectValues={setSelectValues}
              lastSelectValues={lastSelectValues}
              setLastSelectValues={setLastSelectValues}
              onChange={onChange}
            />
          );
        })}
    </section>
  );
};

export { FilterItemType };

export default React.memo(Filter);
